<template>
  <form @submit.prevent="handleSubmit(item)">
    <b-row>
      <b-col>
        <b-row>
          <b-col v-if="hasAllowedRoles">
            <div class="form-group">
              <label
                      for="userdata_name"
                      class="form-control-label">{{ $t('views.userdata.form.name') }}:</label>
              <input
                      id="userdata_name"
                      v-model="item.name"
                      :class="['form-control', isInvalid('name') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('name', $event.target.value)">
              <div
                      v-if="isInvalid('name')"
                      class="invalid-feedback">{{ violations.name }}</div>
            </div>
          </b-col>
          <b-col v-if="hasAllowedRoles">
            <div class="form-group">
              <label
                      for="userdata_surname"
                      class="form-control-label">{{ $t('views.userdata.form.surname') }}:</label>
              <input
                      id="userdata_surname"
                      v-model="item.surname"
                      :class="['form-control', isInvalid('surname') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('surname', $event.target.value)">
              <div
                      v-if="isInvalid('surname')"
                      class="invalid-feedback">{{ violations.surname }}</div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col v-if="hasAllowedRoles">
            <div class="form-group">
              <label
                      for="userdata_street"
                      class="form-control-label">{{ $t('views.userdata.form.street') }}:</label>
              <input
                      id="userdata_street"
                      v-model="item.street"
                      :class="['form-control', isInvalid('street') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('street', $event.target.value)">
              <div
                      v-if="isInvalid('street')"
                      class="invalid-feedback">{{ violations.street }}</div>
            </div>
          </b-col>
          <b-col v-if="hasAllowedRoles">
            <div class="form-group">
              <label
                      for="userdata_city"
                      class="form-control-label">{{ $t('views.userdata.form.city') }}:</label>
              <input
                      id="userdata_city"
                      v-model="item.city"
                      :class="['form-control', isInvalid('city') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('city', $event.target.value)">
              <div
                      v-if="isInvalid('city')"
                      class="invalid-feedback">{{ violations.city }}</div>
            </div>
          </b-col>
          <b-col v-if="hasAllowedRoles">
            <div class="form-group">
              <label
                      for="userdata_postcode"
                      class="form-control-label">{{ $t('views.userdata.form.postcode') }}:</label>
              <input
                      id="userdata_postcode"
                      v-model="item.postcode"
                      :class="['form-control', isInvalid('postcode') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('postcode', $event.target.value)">
              <div
                      v-if="isInvalid('postcode')"
                      class="invalid-feedback">{{ violations.postcode }}</div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-group">
              <label
                      for="userdata_mobilePhone"
                      class="form-control-label">{{ $t('views.userdata.form.mobilePhone') }}:</label>
              <input
                      id="userdata_mobilePhone"
                      v-model="item.mobilePhone"
                      :class="['form-control', isInvalid('mobilePhone') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('mobilePhone', $event.target.value)">
              <div
                      v-if="isInvalid('mobilePhone')"
                      class="invalid-feedback">{{ violations.mobilePhone }}</div>
            </div>
          </b-col>
          <b-col v-if="hasAllowedRoles">
            <div class="form-group">
              <label
                      for="userdata_userEmail"
                      class="form-control-label">{{ $t('views.userdata.form.userEmail') }}:</label>
              <input
                      id="userdata_userEmail"
                      v-model="item.userEmail"
                      :class="['form-control', isInvalid('userEmail') ? 'is-invalid' : '']"
                      type="email"
                      placeholder=""
                      @input="handleUpdateField('userEmail', $event.target.value)">
              <div
                      v-if="isInvalid('userEmail')"
                      class="invalid-feedback">{{ violations.userEmail }}</div>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <div class="form-group">
              <label
                      for="userdata_extraInfo"
                      class="form-control-label">{{ $t('views.userdata.form.extraInfo') }}:</label>
              <input
                      id="userdata_extraInfo"
                      v-model="item.extraInfo"
                      :class="['form-control', isInvalid('extraInfo') ? 'is-invalid' : '']"
                      type="text"
                      placeholder=""
                      @input="handleUpdateField('extraInfo', $event.target.value)">
              <div
                      v-if="isInvalid('extraInfo')"
                      class="invalid-feedback">{{ violations.extraInfo }}</div>
            </div>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <div class="float-right">
          <button type="submit" class="btn btn-success">{{ $t('buttons.save') }}</button>
          <b-btn class="btn btn-default" v-if="routeName === 'UserProfile'" @click="closeModal()">{{ $t('buttons.close') }}</b-btn>
        </div>
      </b-col>
    </b-row>
  </form>
</template>

<script>
import { getUserRoles } from '@/utils/checkRoles'

export default {
  props: {
    handleSubmit: {
      type: Function,
      required: true
    },

    handleUpdateField: {
      type: Function,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },

  data () {
    return {
      routeName: ''
    }
  },

  computed: {
    hasAllowedRoles () {
      const roles = getUserRoles().roles
      return roles.includes('ROLE_OWNER') || roles.includes('ROLE_SUPER_USER')
    },
    // eslint-disable-next-line
    item () {
      return this.initialValues || this.values
    },

    violations () {
      return this.errors || {}
    }
  },

  created () {
    this.routeName = this.$route.name
  },

  methods: {
    closeModal () {
      this.$store.state.modals.profile.update.close = 1
    },
    isInvalid (key) {
      return Object.keys(this.violations).length > 0 && this.violations[key]
    }
  }
}
</script>
